var render = function render(){var _vm=this,_c=_vm._self._c;return _c('model-context-menu',{ref:"contextMenu",attrs:{"model-class":_vm.modelClass},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('actions',{attrs:{"opportunity":slotProps.data.opportunity,"model":slotProps.model},on:{"close":_vm.$refs.contextMenu.close}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }